<template>
  <div class="review">
    <h2 class="title is-4">Bilan</h2>
    <b-loading :active="loading" :is-full-page="false" />
    <b-tabs v-if="!loading" v-model="activeSubTab" :animated="false">
      <b-tab-item v-if="queclinkTrackers.length" label="Consommation">
        <edit-live-review-consumption
          :live="live"
          :liveVehicles="liveVehicles"
          :liveStages="liveStages"
          :queclinkTrackers="queclinkTrackers"
        />
      </b-tab-item>
      <b-tab-item label="Réseau">
        <edit-live-review-tracker
          :live="live"
          :liveVehicles="liveVehicles"
          :liveStages="liveStages"
          :spotTrackers="spotTrackers"
          :queclinkTrackers="queclinkTrackers"
        />
      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>
import EditLiveReviewTracker from './EditLiveReviewTracker'
import EditLiveReviewConsumption from './EditLiveReviewConsumption'

export default {
  name: 'EditLiveReview',

  components: {
    EditLiveReviewTracker,
    EditLiveReviewConsumption,
  },

  props: {
    live: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: true,
      activeSubTab: 0,
      liveVehicles: [],
      liveStages: [],
      spotTrackers: [],
      queclinkTrackers: [],
    }
  },

  watch: {
    'live.id': {
      handler: 'load',
      immediate: true,
    },
  },

  methods: {
    async load() {
      this.loading = true
      this.activeSubTab = 0

      const [liveVehicles, liveStages, spotTrackers, queclinkTrackers] = await Promise.all([
        this.fetchLiveVehicles(),
        this.fetchLiveStages(),
        this.fetchSpotTrackers(),
        this.fetchQueclinkTrackers(),
      ])

      this.liveVehicles = liveVehicles
      this.liveStages = liveStages
      this.spotTrackers = spotTrackers
      this.queclinkTrackers = queclinkTrackers

      this.loading = false
    },

    async fetchLiveVehicles() {
      try {
        return await this.$services.liveVehicleService.getAll(this.live.id)
      } catch (error) {
        return []
      }
    },

    async fetchLiveStages() {
      try {
        return await this.$services.liveStageService.getAll(this.live.id)
      } catch (error) {
        return []
      }
    },

    async fetchSpotTrackers() {
      try {
        return await this.$services.spotTrackerService.getAllByLiveId(this.live.id)
      } catch (error) {
        return []
      }
    },

    async fetchQueclinkTrackers() {
      try {
        return await this.$services.queclinkTrackerService.getAllByLiveId(this.live.id)
      } catch (error) {
        return []
      }
    },
  },
}
</script>
